import React, { useState } from 'react';
import { TiArrowBack } from "react-icons/ti";
import './Auth.css';

const SignUp = ({ onSignUpSuccess, onNavigateToLogin }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validaciones
    if (!formData.name.trim()) {
      setError('Please enter your full name');
      return;
    }
    if (!formData.email.trim()) {
      setError('Please enter your email');
      return;
    }
    if (!formData.phone.trim()) {
      setError('Please enter your phone number');
      return;
    }
    if (!formData.password) {
      setError('Please enter a password');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setIsLoading(true);

    try {
      // Simular registro
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Guardar datos temporalmente para la verificación
      localStorage.setItem('signupData', JSON.stringify(formData));
      
      onSignUpSuccess();
      
    } catch (err) {
      setError('Registration failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container signup-container">
      <div className="auth-header">
        <button className="back-button" onClick={onNavigateToLogin}>
          <TiArrowBack />
        </button>
        <h2>Crea tu Cuenta</h2>
        <p>Unete a Coffee Community</p>
      </div>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label>Full Name</label>
          <input 
            type="text" 
            name="name"
            placeholder="Enter your full name"
            value={formData.name}
            onChange={handleChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Email</label>
          <input 
            type="email" 
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Phone Number</label>
          <input 
            type="tel" 
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Password</label>
          <input 
            type="password" 
            name="password"
            placeholder="Create a password (min 6 characters)"
            value={formData.password}
            onChange={handleChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Confirm Password</label>
          <input 
            type="password" 
            name="confirmPassword"
            placeholder="Confirm your password"
            value={formData.confirmPassword}
            onChange={handleChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="terms-agreement">
          <label className="checkbox-label">
            <input type="checkbox" required />
            <span>
              Acepto los <a href="/terms">Terminos de servicio</a> y <a href="/privacy">Politica de Privacidad</a>
            </span>
          </label>
        </div>
        
        <button 
          type="submit" 
          className="auth-btn primary"
          disabled={isLoading}
        >
          {isLoading ? 'Creating Account...' : 'Create Account'}
        </button>
        
        <div className="auth-divider">
          <span>Ya tienes una Cuenta?</span>
        </div>
        
        <button 
          type="button"
          className="auth-btn secondary"
          onClick={onNavigateToLogin}
          disabled={isLoading}
        >
          Login Instead
        </button>
      </form>
    </div>
  );
};

export default SignUp;